import React from 'react'
import { node, array, bool, func, oneOfType } from 'prop-types'

import ProductListVertical from 'gatsby-theme-marketplace-base/src/components/ProductList/VerticalList'
import EmptyState from 'gatsby-theme-marketplace-base/src/components/Category/EmptyState'

const AppsSection = ({
  items,
  isFetching,
  isFeatured,
  children,
  listComponent: ListComponent = ProductListVertical,
  ...rest
}) => {
  return (
    <section {...rest}>
      {children}

      {!isFetching && items?.length === 0 ? (
        <EmptyState key="empty-state" />
      ) : (
        <ListComponent
          isFetching={isFetching}
          isFeatured={isFeatured}
          items={items}
        />
      )}
    </section>
  )
}

AppsSection.propTypes = {
  isFetching: bool,
  items: array,
  isFeatured: bool,
  children: node,
  listComponent: oneOfType([node, func]),
}

export default AppsSection
